import styled from 'styled-components'
const SupplierOrderReviewWrapper = styled.div`

  .attach-file:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.tokens.border};
    padding-bottom: 4px;
  }

  .truck-dispatch:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.tokens.border};
    padding-bottom: 4px;
  }

  .image-container {
    display: inline;
    flex-wrap: wrap;
  }

  .image-container > img {
    border: 1px solid ${(props) => props.theme.tokens.border};
    border-radius: 1px;
    padding: 1px;
    margin: 1px;
    width: 30px;
  }

  .chat-button {
    background: ${(props) => props.theme.tokens.success};

    i {
      color: ${(props) => props.theme.tokens.textOnAccent};
    }
  }

  .icon-button {
    width: 40px;
    margin-right: 8px;
  }

  .filter-toggle {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .filter-panel {
    background: ${(props) => props.theme.tokens.surfaceHover};
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 6px;
    padding: 16px;
    margin-top: 16px;
  }

  .filter-panel.filter-panel--hidden {
    display: none;
  }

  .filter-panel .filter-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .filter-panel .filter-label {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textSecondary};
    font-weight: 500;
  }

  .filter-panel .filter-field--checkbox {
    justify-content: flex-end;
    height: 100%;
    padding-bottom: 4px;
  }

  .supplier-review-mobile-list .ant-list-item {
    padding: 0;
    border: none;
  }

  .supplier-review-mobile-list .supplier-review-card {
    width: 100%;
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
  }

  .supplier-review-mobile-list .card-row {
    margin-bottom: 6px;
  }

  .supplier-review-mobile-list .card-row:last-child {
    margin-bottom: 0;
  }

  .supplier-review-mobile-list .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-weight: 500;
  }

  .supplier-review-mobile-list .card-header .order-number {
    font-size: 15px;
  }

  .supplier-review-mobile-list .card-header .card-state {
    text-align: right;
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textSecondary};
  }

  .supplier-review-mobile-list .subtle {
    color: ${(props) => props.theme.tokens.textMuted};
    font-size: 12px;
  }

  .supplier-review-mobile-list .card-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    font-size: 13px;
    padding-top: 6px;
    border-top: 1px dashed ${(props) => props.theme.tokens.borderSubtle};
  }

  .supplier-review-mobile-list .card-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px dashed ${(props) => props.theme.tokens.borderSubtle};
  }
`
export default SupplierOrderReviewWrapper